@if (shouldShow()) {
  <section class="border-y border-info/25 bg-info/10 px-4 py-3" aria-label="Email verification reminder">
    <div class="mx-auto flex max-w-[84rem] flex-wrap items-center justify-between gap-3">
      <div class="flex min-w-0 items-start gap-3 text-sm">
        <span class="iconify tabler--mail-check mt-0.5 shrink-0 text-base text-info"></span>
        <div>
          <p class="font-medium text-white [overflow-wrap:anywhere]">Verify {{ user()?.email }} directly with Fluxtail.</p>
          <p class="text-muted">It is optional for normal use, but required before sending team invitations.</p>
          @if (message()) {
            <p class="mt-1 text-ui-meta text-info">{{ message() }}</p>
          }
        </div>
      </div>
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="rounded-sm2 border border-info/40 bg-panel px-3 py-2 font-label text-ui-label font-bold uppercase tracking-ui-label text-info transition hover:bg-panel2 hover:text-white disabled:cursor-not-allowed disabled:opacity-60"
          [disabled]="sending()"
          (click)="resend()"
        >
          {{ sending() ? 'Sending…' : 'Send verification email' }}
        </button>
        <button
          type="button"
          class="grid size-8 place-items-center rounded-sm2 text-muted transition hover:bg-panel2 hover:text-white"
          aria-label="Dismiss verification reminder for this session"
          (click)="dismiss()"
        >
          <span class="iconify tabler--x text-base"></span>
        </button>
      </div>
    </div>
  </section>
}
